export enum UpdateJobResult {
  UPDATED_SUCCESS = '0',
  UPDATED_IGNORED = '1',
  UPDATED_LIST_PRECOND_UNMET = '2',
  UPDATED_ERROR = '3',
  UPDATED_ERROR_UNIMPLEMENTED = '4',
  UPDATED_ERROR_BUSY = '5',
  UPDATED_ERROR_DISK_SPACE = '6',
  UPDATED_ERROR_FILE_CORRUPT = '7',
  UPDATED_ERROR_BASE_VERSION_MISSING = '8',
  UPDATED_ERROR_DECRYPTION = '9',
  UPDATED_ERROR_MANIFEST_MISMATCH = '10',
  UPDATED_ERROR_KERNEL_FAILED = '11',
  UPDATED_ERROR_FILESYSTEM = '12',
  UPDATED_ERROR_DOWNLOAD_PACKAGE = '13',
  UPDATED_ERROR_DOWNLOAD_LIST = '14',
  UPDATED_ERROR_SERVER_UNREACHABLE = '15',
}
